import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid"

export default function ViewerLink({
  href,
  label,
  showLinkIcon = false,
  truncateValue = false,
}) {
  if (!showLinkIcon) {
    return (
      <a
        href={href}
        onClick={(e) => e.stopPropagation()}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary-4"
      >
        {label}
      </a>
    )
  }

  const icon = (
    <a
      href={href}
      onClick={(e) => e.stopPropagation()}
      target="_blank"
      rel="noopener noreferrer"
      className="ml-1 hidden shrink-0 text-primary-4 group-hover/value:inline"
      aria-label={`Open ${label} in a new tab`}
    >
      <ArrowTopRightOnSquareIcon className="inline h-4 w-4" />
    </a>
  )

  if (!truncateValue) {
    return (
      <>
        {label}
        {icon}
      </>
    )
  }

  return (
    <span className="inline-flex max-w-full items-center align-bottom">
      <span className="truncate">{label}</span>
      {icon}
    </span>
  )
}
